import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('PurchasingGroup?page=' + page, {params});
    }, 
    getByPlant(plant) {
        return Service().get('PurchasingGroup/get-by-plant/' + plant);
    },
    show(id) {
        return Service().get('PurchasingGroup/show/'+id);
    },    
    create(params) {
        return Service().post('PurchasingGroup/create', params);
    },
    update(id, params) {
        return Service().post('PurchasingGroup/update/'+id, params);
    },
    delete(id) {
        return Service().post('PurchasingGroup/delete/'+id);
    }
}